import {IControl, IDataSource, SourceCode, ITableDefinition} from '@datahu/core'
import {I18n} from '../i18n'
import getControls from './CDataControls'
import {CDataHelper, ICDataConfig} from './CDataHelper'

export class CDataDataSource implements IDataSource {
  language: string = 'zh-cn'
  helper: CDataHelper
  disableNew: boolean = true
  constructor(language: string, config?: object) {
    this.language = language
    var i18n = I18n.get(this.language)
    if (config) this.config = config as ICDataConfig

    this.helper = new CDataHelper(this.config)

    // 数据源配置界面的配置控件
    this.controls = getControls(i18n)
    this.title = '在线数据'
    this.description = ''
  }
  getControls(): IControl[] {
    return this.controls
  }

  controls: IControl[] = []

  // 数据源默认配置值
  config = {
    user: null,
    tables: []
  } as ICDataConfig

  icon: string = `<svg t="1620814089232" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3822"><path d="M480.311123 16.446859c-260.743086 0-472.118406 211.348132-472.118406 472.118406 0 260.712877 211.37532 472.122434 472.118406 472.122434 260.738051 0 472.147608-211.409557 472.147608-472.122434C952.45873 227.794991 741.049173 16.446859 480.311123 16.446859zM480.311123 897.737906c-225.974387 0-409.168614-183.189192-409.168614-409.172641 0-225.980429 183.194226-409.169621 409.168614-409.169621 226.002582 0 409.197816 183.189192 409.197816 409.169621C889.508938 714.548715 706.314712 897.737906 480.311123 897.737906z" p-id="3823" fill="#e0620d"></path><path d="M563.635968 626.332003c-20.899685 17.399454-46.349873 26.063433-76.378759 26.063433-24.711071 0-47.703242-6.452671-68.972486-19.118354-21.1474-12.726101-36.762501-31.966298-46.842282-57.660173-10.02339-25.7553-15.062274-55.820437-15.062274-90.312218 0-26.739111 4.243376-52.742126 12.726101-77.885188 8.481718-25.202473 23.114015-45.245226 44.139572-60.247082 20.897671-14.874977 46.963119-22.313473 78.194328-22.313473 27.076446 0 49.572181 6.7024 67.465051 20.102164 17.886828 13.52765 31.535314 35.038567 40.940424 64.485423l52.803551-12.477379c-10.879316-37.376754-30.060102-66.392626-57.783023-87.046611-27.660489-20.654991-61.782713-31.104331-102.381774-31.104331-35.779698 0-68.546538 8.232996-98.297499 24.588221-29.816415 16.290779-52.742126 40.199294-68.911061 71.613772-16.167928 31.473889-24.224704 68.297816-24.224704 110.592616 0 38.668698 7.10116 74.93879 21.45654 108.629023 14.262739 33.810062 35.165445 59.567376 62.518808 77.331353 27.357391 17.827417 62.88736 26.678693 106.657373 26.678693 42.201152 0 77.979843-11.554994 107.178984-34.666994 29.263587-23.177454 49.488602-56.805254 60.737477-100.88038l-53.67156-13.526643C598.552691 583.302114 584.417838 609.058421 563.635968 626.332003z" p-id="3824" fill="#e0620d"></path></svg>`
  title: string = ''
  description: string = ''

  sourceCode: SourceCode = SourceCode.SQL
  getTables(): Promise<Array<ITableDefinition>> {
    return this.helper.getTables()
  }
  getData(tables: Array<ITableDefinition>): Promise<Array<object>> {
    return this.helper.getData(tables)
  }
}
